// extracted by mini-css-extract-plugin
export default {"container":"UserCount_container__9UEaw","fraction":"UserCount_fraction__cylUO","line":"UserCount_line__T8WrX","text":"UserCount_text__4cfbR"};